import { MetadataTranslationId } from '../../metadata-translations/entities/metadata-translation.entity';

enum ExportLocationIdBrand {
    _ = 'ExportLocationId'
}
export type ExportLocationId = string & ExportLocationIdBrand;

export interface ExportJobResponse {
    NrOfResults?: number;
    StartIndex?: number;
    TotalNrOfResults?: number;
    Results: ExportLocation[];
}

export interface ExportLocation {
    Id: ExportLocationId;
    Name: string;
    UniqueFolder: boolean;
    HttpAccessible: boolean;
    RestrictDownloadToExporter: boolean;
    HttpUrl?: string;
    ExportReasonRequired: boolean;
    ExportReasons: string[] | null;
    CustomExportReasonAllowed: boolean;
    ZipExportAllowed?: boolean;
    BrowseExportAllowed?: boolean;
    Options?: ExportLocationOptions;
    Context: ExportLocationContext;
    CreationDate: string;
    LastModifiedDate: string;
    OrganisationId?: number;
    AllowedForAllOrganisations: boolean;
    AllowedForAllUsers: boolean;
    Default: boolean;
    Priority: number;
    Protocol?: ExportLocationProtocol;
    StoragePoolId?: number;
    Server?: ExportLocationServer;
    TempLocation?: ExportLocationTempLocation;
    FilenameExpression: string;
}

export interface ExportLocationOptions {
    Metadata?: ExportLocationOptionsMetadata;
    Video?: ExportLocationOptionsVideo;
    Audio?: ExportLocationOptionsAudio;
    Image?: ExportLocationImageOptions;
    Document?: ExportLocationOptionsDocument;
}

export interface BaseImageOptions {
    Height?: number;
    Width?: number;
    Container?: ImageContainer | null;
    ColorSpace?: ColorSpace | null;
    Watermark?: Watermark;
}

export interface ExportLocationImageOptions extends BaseImageOptions {
    Cropping?: ExportImageCropping;
    Rotate?: number;
    Flip?: ExportImageFlip;
}

export interface ExportImageCropping {
    Top?: number;
    Bottom?: number;
    Left?: number;
    Right?: number;
}

export enum ExportImageFlip {
    HORIZONTAL = 'HORIZONTAL',
    VERTICAL = 'VERTICAL',
    NONE = 'NONE'
}

export interface ExportLocationOptionsDocument extends BaseImageOptions {}

export enum ImageContainer {
    JPG = 'JPG',
    PNG = 'PNG',
    TIFF = 'TIFF',
    PDF = 'PDF'
}

export enum ColorSpace {
    sRGB = 'SRGB',
    CMYK = 'CMYK',
    RGB = 'RGB',
    LAB = 'LAB',
    AdobeRGB = 'AdobeRGB'
}
export interface ExportLocationOptionsMetadata {
    Type: MetadataType;
    Format: MetadataFormat;
    OnlyMetadata: boolean;
    MetadataTranslationId?: MetadataTranslationId;
}

export enum MetadataType {
    SIDECAR = 'Sidecar',
    BURN = 'Burn'
}

export enum MetadataFormat {
    MEDIAHAVEN = 'Mediahaven',
    DUBLIN_CORE = 'DublinCore',
    METS = 'Mets',
    METS_MHS = 'MetsMhs',
    METS_MHS_TREE = 'MetsMhsTree',
    MHS = 'Mhs'
}

export interface ExportLocationOptionsAudio {
    SampleRate: number;
    Bitrate: number;
    Container: AudioContainers;
}

export enum AudioContainers {
    MP3 = 'MP3',
    WAV = 'WAV',
    AIFF = 'AIFF',
    AAC = 'AAC',
    OGG = 'OGG',
    WMA = 'WMA',
    FLAC = 'FLAC'
}
export interface ExportLocationOptionsVideo {
    Height: number;
    Width: number;
    Bitrate: number;
    Container: VideoContainers;
    Channels: number;
    Watermark?: Watermark;
    Subtitle: string;
}

export enum VideoContainers {
    MP4 = 'MP4',
    FLV = 'FLV',
    AVI = 'AVI',
    WMV = 'WMV',
    PRORES = 'PRORES'
}

export interface Watermark {
    Source: string;
    Scale: number;
    Opacity: number;
    Position: WatermarkPosition;
}

export enum WatermarkPosition {
    CENTER = 'CENTER',
    TILED = 'TILED',
    NORTH = 'NORTH',
    NORTH_EAST = 'NORTH_EAST',
    EAST = 'EAST',
    SOUTH_EAST = 'SOUTH_EAST',
    SOUTH = 'SOUTH',
    SOUTH_WEST = 'SOUTH_WEST',
    WEST = 'WEST',
    NORTH_WEST = 'NORTH_WEST'
}

export interface ExportLocationContext {
    Combine: string[];
    Source: string[];
    MetadataType: string[];
    MetadataTypeForZip: string[];
    MultipleFiles: boolean;
    Transformation: boolean;
    VideoContainers: VideoContainers;
    AudioContainers: AudioContainers;
    PredefinedOptions: string[];
    AreOptionsEditable: boolean;
}

export enum ExportLocationProtocol {
    File = 'File',
    Ftp = 'Ftp',
    FtpActive = 'FtpActive',
    Ftps = 'Ftps',
    FtpsActive = 'FtpsActive',
    Castor = 'Castor',
    S3 = 'S3',
    Azure = 'Azure',
    Glacier = 'Glacier',
    Jwplayer = 'Jwplayer',
    Youtube = 'Youtube'
}

export interface ExportLocationServer {
    Address: string;
    Port: number;
    Username?: string;
    Password?: string;
    Path: string;
}

export interface ExportLocationTempLocation {
    Path: string;
    Filename: string;
}
